import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.84375 6.90625H3.78125C1.67578 6.90625 0 8.60352 0 10.6875C0 11.0742 0.300781 11.375 0.6875 11.375H8.9375C9.30273 11.375 9.625 11.0742 9.625 10.6875C9.625 8.60352 7.92773 6.90625 5.84375 6.90625ZM1.03125 10.3438C1.20312 8.99023 2.36328 7.9375 3.78125 7.9375H5.84375C7.24023 7.9375 8.40039 8.99023 8.57227 10.3438H1.03125ZM4.8125 5.875C6.31641 5.875 7.5625 4.65039 7.5625 3.125C7.5625 1.62109 6.31641 0.375 4.8125 0.375C3.28711 0.375 2.0625 1.62109 2.0625 3.125C2.0625 4.65039 3.28711 5.875 4.8125 5.875ZM4.8125 1.40625C5.75781 1.40625 6.53125 2.17969 6.53125 3.125C6.53125 4.0918 5.75781 4.84375 4.8125 4.84375C3.8457 4.84375 3.09375 4.0918 3.09375 3.125C3.09375 2.17969 3.8457 1.40625 4.8125 1.40625Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
